import { useUBL } from '@common/log-manager';
import { getUrl } from '@domains/pdp-common';

export const useProductShareUBL = () => {
  const sendUBL = useUBL();

  const clickShareUBL = () => {
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      object_type: 'button',
      object_id: 'share',
    });
  };

  const shareClickUBL = (catalog_product_id: string) => {
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      navigation_sub: {
        page_url: getUrl(),
      },
      object_type: 'button',
      object_id: 'share',
      data: { catalog_product_id },
    });
  };

  const clickCopyAffiliateUrlUBL = () =>
    sendUBL({
      category: 'click',
      navigation: 'browser_share_list',
      navigation_sub: {
        page_url: getUrl(),
      },
      object_type: 'button',
      object_id: 'copy_url',
      object_section: 'reward',
    });

  const clickCopyUrlUBL = () =>
    sendUBL({
      category: 'click',
      navigation: 'browser_share_list',
      navigation_sub: {
        page_url: getUrl(),
      },
      object_type: 'button',
      object_id: 'copy_url',
    });

  const clickShareKakaoUBL = () =>
    sendUBL({
      category: 'click',
      navigation: 'browser_share_list',
      navigation_sub: {
        page_url: getUrl(),
      },
      object_type: 'button',
      object_id: 'share_kakao',
    });

  return {
    clickShareUBL,
    shareClickUBL,
    clickCopyAffiliateUrlUBL,
    clickCopyUrlUBL,
    clickShareKakaoUBL,
  };
};
